import { Box, Chip, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { ICON_BUTTON_TYPE } from '../../../constants';
import IconButton from '../../../components/IconButton';
import TopBar from './TopBar';
import AddInsuranceModal from './AddInsuranceModal';
import { deleteUserInsuranceApi, getUserInsuranceApi } from '../../../utils/api';
import { isEmpty } from 'lodash';
import { useMutation, useQuery } from 'react-query';

const HealthInsurance = ({ user, recipient }) => {
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [activeEditData, setActiveEditData] = React.useState(null);

  const { data, isLoading, refetch } = useQuery(
    ['getUserInsuranceApi'],
    () => getUserInsuranceApi({ userId: user?._id, recipientId: recipient?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  const deleteInsuranceHandler = useMutation(deleteUserInsuranceApi, {
    onSuccess: async ({ data }) => {
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDelete = (item) => {
    deleteInsuranceHandler.mutate({ userId: user?._id, recipientId: recipient?._id, insuranceId: item?._id });
  };

  return (
    <Grid>
      <TopBar onClick={() => setShowAddModal(true)} btnText="Add Insurance" />

      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} />
        </Grid>
      )}

      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center">
          No Insurances found!
        </Typography>
      )}

      {!isLoading &&
        !isEmpty(data?.data) &&
        data?.data.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '18px',
              backgroundColor: 'rgba(255, 255, 255, 1)',
              borderRadius: '20px',
              gap: '15px',
              mt: 2,
            }}
          >
            <Grid container justifyContent="space-between" alignItems="center" sx={{ height: '60px' }}>
              <img src={item?.imageUrl} alt={item?.title} style={{ width: '152px', height: 'auto' }} />
              <IconButton type={ICON_BUTTON_TYPE.delete} onClick={() => handleDelete(item)} />
            </Grid>

            <Divider sx={{ width: '100%' }} />

            <Grid container spacing={10}>
              {[
                { label: 'Member ID', value: item?.member },
                { label: 'Group #', value: item?.group },
                { label: 'BIN', value: item?.bin },
                { label: 'Benefit Plan', value: item?.benefitPlan },
                { label: 'Plan', value: item?.plan },
                { label: 'Effective Date', value: item?.date },
              ].map((item, index) => (
                <Grid item key={index}>
                  <Typography variant="body2" color="textSecondary">
                    {item.label}
                  </Typography>
                  <Typography variant="body1" color="textPrimary">
                    {item.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>

            <Divider sx={{ width: '100%' }} />

            <Grid container spacing={10}>
              <Grid item>
                <Typography variant="body2" color="textSecondary">
                  Dependents
                </Typography>
                <Grid container spacing={1}>
                  {item?.dependents.map((name, index) => (
                    <Grid item key={index}>
                      <Chip
                        label={name}
                        sx={{
                          backgroundColor: 'rgba(245, 245, 247, 1)',
                          color: 'rgba(29, 29, 31, 1)',
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item>
                <Typography variant="body2" color="textSecondary">
                  Prices
                </Typography>
                <Grid container spacing={1}>
                  {item?.prices.map((price, index) => (
                    <Grid item key={index}>
                      <Chip
                        label={price}
                        sx={{
                          backgroundColor: 'rgba(245, 245, 247, 1)',
                          color: 'rgba(29, 29, 31, 1)',
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ))}
      <AddInsuranceModal
        show={showAddModal}
        onClose={() => {
          setShowAddModal(false);
          setActiveEditData(null);
        }}
        recipient={recipient}
        refetch={refetch}
        activeEditData={activeEditData}
      />
    </Grid>
  );
};

export default HealthInsurance;
